import { Button } from "@talladega/components";
import { ArrowRightIcon, CloseIcon, DollarCoinIcon } from "@talladega/icons";
import { Trans, useTranslation } from "next-i18next";
import { useState } from "react";

type Props = {
  dealCount: number;
  onResumeClick?: () => void;
};

const ResumeFooter = ({ dealCount, onResumeClick }: Props) => {
  const { t } = useTranslation(["tradeInPage", "common"]);

  const [showFooter, setShowFooter] = useState(true);

  return showFooter && dealCount > 0 ? (
    <div className="sticky bottom-0 bg-primary-600 p-3">
      <div className="w-4/5 mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 justify-between">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <div className="w-full sm:w-fit flex flex-row justify-between items-start">
            <div className="bg-white rounded-xl p-3 border border-gray-200">
              <DollarCoinIcon className="text-primary-700 text-3xl" />
            </div>
            <button
              className="sm:hidden"
              onClick={() => setShowFooter(false)}
              type="button"
            >
              <CloseIcon className="text-3xl text-white/60" />
            </button>
          </div>
          <div className="text-white">
            <Trans
              ns="common"
              i18nKey="looks_like_youve_got_offers_waiting"
              count={dealCount}
              components={[<span className="font-semibold" />]}
            />
          </div>
        </div>
        <div className="w-full sm:w-fit sm:flex sm:items-center sm:gap-3">
          <Button
            rightIcon={<ArrowRightIcon className="text-primary-700 text-xl" />}
            buttonStyle="white"
            spacing="tight-hug"
            className="border border-primary-200 w-full sm:w-fit"
            onClick={() => {
              onResumeClick?.();
              setShowFooter(false);
            }}
          >
            <span className="text-primary-700 font-semibold">
              {t("common:resume")}
            </span>
          </Button>
          <button
            className="hidden sm:inline"
            onClick={() => setShowFooter(false)}
            type="button"
          >
            <CloseIcon className="text-3xl text-white/60" />
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default ResumeFooter;
